import { render, staticRenderFns } from "./cardFooter.vue?vue&type=template&id=4549bfa9&"
import script from "./cardFooter.vue?vue&type=script&lang=js&"
export * from "./cardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports